import { getServiceConfigurationOrThrow } from './get-service-configuration';
import { INFOMANIAK_SERVICE_IDS } from './infomaniak-service-ids.enum';

export function getIconOfServiceIdUsingServicesConfig(
  serviceId: INFOMANIAK_SERVICE_IDS,
): string {
  return `icon-product-${getServiceConfigurationOrThrow(serviceId).alias}`;
}
